import { useForm } from 'vee-validate'
import { registerValidationSchema } from '~/validators/register.schema'
import { loginValidationSchema } from '~/validators/login.schema'

export const useLoginForm = () =>
  useForm({
    initialValues: {
      username: '',
      password: '',
      captchaToken: ''
    },
    validationSchema: loginValidationSchema,
  })

export const useRegisterForm = () =>
  useForm({
    initialValues: {
      username: '',
      fullname: '',
      password: '',
      confirmPassword: '',
      phoneNumber: '',
      termAcception: false,
      captchaToken: ''
    },
    validationSchema: registerValidationSchema,
  })
